import React from "react"
import Section from "../../../../core/layout/main/section/Section"
import PressArticleCard from "../../blocks/press-article-card/PressArticleCard"
import * as classNames from "./LastPressArticles.module.scss"
import Button from "../../blocks/button/Button"
function LastPressArticles({ label, buttonCtaLink, buttonText, pageContext }) {
  const pressArticles = pageContext.pressArticles

  return (
    <Section className={classNames.ArticleCardBlock + " mt-4 xxlarge"}>
      <h2 className="pb-3">{label}</h2>
      <div className={classNames.articlesCardsContainer}>
        {pressArticles
          .slice()
          .sort(
            (a, b) => new Date(b.attributes.date) - new Date(a.attributes.date)
          ) // Sort articles by date in descending order
          .filter(
            (pressArticle) =>
              new Date(pressArticle.attributes.date) <= new Date()
          ) // Filter out articles with a date greater than today's date
          .slice(0, 4)
          .map((pressArticle) => (
            <PressArticleCard
              key={pressArticle.id}
              data={pressArticle}
            />
          ))}
      </div>

      <div className="mt-4">
        <Button
          aspect={"contrastant"}
          color={"primary"}
          size={"large"}
          className="fluid mt-2 mb-6"
          ctalink={buttonCtaLink}
        >
          {buttonText}
        </Button>
      </div>
    </Section>
  )
}

export const name = "LastPressArticles"

export const init = (componentData, pageContext) => {
  return (
    <LastPressArticles
      label={componentData.label}
      buttonCtaLink={componentData.buttonCtaLink}
      buttonText={componentData.buttonText}
      pageContext={pageContext}
    />
  )
}

export default LastPressArticles
